.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: var(--color-grey-8-5);
  border-radius: var(--border-radius-medium);
}

.title {
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.42rem;
  text-align: center;
  margin-top: 6.4rem;
}

.description {
  font-size: 1.8rem;
  line-height: 2.6rem;
  color: var(--color-grey-3);
  text-align: center;
  margin-top: 1.6rem;
}
